import React from 'react'
import { connect } from 'react-redux'
import SecondaryButton from '../SecondaryButton/SecondaryButton'
import PrimaryButton from '../PrimaryButton/PrimaryButton'
import Modal from '../Modal/Modal'

const ConfirmModal = ({ open, onConfirm, onAbandon, onCloseModal, modalTitle, modalDescription }) => (
  <Modal open={open} onCloseModal={() => onCloseModal()}>
    <h1 className="modal__title">{modalTitle}</h1>
    <p className="modal__description" style={{fontSize: 14, lineHeight: 2}}>
    {modalDescription}
    </p>
    <PrimaryButton onClick={onConfirm}>Confirmar</PrimaryButton>
    <SecondaryButton onClick={onAbandon}>Cancelar</SecondaryButton>
  </Modal>
)

const mapStateToProps = state => ({
  selected: state.farm.selected,
})

export default connect(mapStateToProps)(ConfirmModal)
